import logger from 'js-logger';
import request from '../wrapper/auth.request';

/**
 * Storage utils tools.
 */
import { createOrReplaceUserToken, removeUserToken } from '../utils/auth.utils';
import { clearAuthorization, getLog } from '../wrapper/auth.request.configurator';

/**
 * Init logger
 */
if (logger) {
  logger.useDefaults();
  const log = getLog();
  if (log) logger.setHandler(log);
}

/**
 *
 *  Authenticate the user.
 *
 * @param provider
 * @param data
 * @param type
 * @returns promise
 */
const authenticate = (provider, data, type) => {
  logger.info(`Receive authenticate user request with provider: ${provider} and type: ${type}.`);
  switch (provider) {
    case 'google':
    case 'facebook':
    case 'mcontigo': {
      const url = `/v2/auth/${provider === 'mcontigo'
        ? (type === 'login' && 'signin') || 'signup'
        : provider}`;
      const promise = request({ method: 'POST', url, data });
      // write in session the user token
      return promise.then((auth) => {
        createOrReplaceUserToken(auth.token);
        return auth;
      }).catch((error) => {
        if (new RegExp('timeout').test(error) && type === 'login') {
          return Promise.reject(new Error('Operation timeout'));
        }
        return Promise.reject(error);
      });
    }
    default: {
      const cause = `Something is wrong. Unknown provider: ${provider}. Please check your request and try again.`;
      logger.error(cause);
      return Promise.reject(new Error(cause));
    }
  }
};

/**
 *
 * Login the user with the indicate provider.
 * Add a user token on session.
 *
 * @param provider
 * @param data
 * @returns promise
 */
export const signIn = (provider, data) => authenticate(provider, data, 'login');

/**
 *
 * Create and authenticate a user.
 * Add a user token on session.
 *
 * @param provider
 * @param data
 * @returns promise
 */
export const signUp = (provider, data) => authenticate(provider, data, 'register');

/**
 *
 * Logout user of the client side and server side.
 * Remove user token of the session.
 *
 * @returns promise
 */
export const signOut = () => request({ method: 'POST', url: '/auth/logout' }).then(() => {
  removeUserToken();
  clearAuthorization();
});

/**
 *
 *  Activate the user.
 *
 * @param userId
 * @param data
 * @returns promise
 */
export const activate = (userId, data) => {
  logger.info('Receive activate user request with provider.');

  const url = `/v2/auth/active/${userId}`;
  const promise = request({ method: 'POST', url, data });
  // write in session the user token
  return promise.then((auth) => {
    createOrReplaceUserToken(auth.token);
    return auth;
  });
};
